import {observer} from 'mobx-react';
import React from 'react';
import {RolesSelect, UserStatusSelect} from '../../../lib/components';
import {UserSearchFormStore} from './UserSearchFormStore';

@observer
export class UserSearchForm extends React.Component<{ store: UserSearchFormStore }> {
  render() {
    const store = this.props.store;

    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              Search parameters
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6 col-md-4">
                  <div className="form-group">
                    <label>Search string</label>
                    <input type="text" className="form-control"
                           value={store.filter.value}
                           onChange={store.filter.onChangeHandler}/>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className="form-group">
                    <label>Status</label>
                    <UserStatusSelect value={store.status.value}
                                      onChange={store.status.setValue}/>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className="form-group">
                    <label>Roles</label>
                    <RolesSelect value={store.roles.value}
                                 onChange={store.roles.setValue}/>
                  </div>
                </div>

                <div className="w-100"/>

                <div className="col-sm-6 col-md-4">
                  <div className={store.creationDateTime.formGroupClassName}>
                    <label>User created date</label>
                    <input type="text" className="form-control"
                           value={store.creationDateTime.value}
                           onChange={store.creationDateTime.onChangeHandler}
                           onBlur={store.creationDateTime.markTouched}/>
                    <div className="invalid-text">Enter data range values.
                      (YYYYMMDD or YYYYMM or YYYY)
                    </div>
                  </div>
                </div>

                <div className="col-sm-6 col-md-4">
                  <div className={store.lastLoginDateTime.formGroupClassName}>
                    <label>Last login date</label>
                    <input type="text" className="form-control"
                           value={store.lastLoginDateTime.value}
                           onChange={store.lastLoginDateTime.onChangeHandler}
                           onBlur={store.lastLoginDateTime.markTouched}/>
                    <div className="invalid-text">Enter data range values.
                      (YYYYMMDD or YYYYMM or YYYY)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
